/**
 * Debug utility to check authentication environment variables
 * This helps diagnose issues with environment variable configuration
 */

export const getAuthDebugInfo = () => {
  return {
    VITE_LOGIN_REQUIRED: import.meta.env.VITE_LOGIN_REQUIRED,
    VITE_FORCE_LOGIN_ENABLED: import.meta.env.VITE_FORCE_LOGIN_ENABLED,
    VITE_LOGIN_EMAIL: import.meta.env.VITE_LOGIN_EMAIL,
    VITE_LOGIN_PASSWORD_EXISTS: !!import.meta.env.VITE_LOGIN_PASSWORD,
    localStorageAuth: localStorage.getItem('addiwise_auth'),
    localStorageExpiry: localStorage.getItem('addiwise_auth_expiry'),
  };
};

export const logAuthDebug = () => {
  console.group('🔐 Auth Debug Info');
  const debugInfo = getAuthDebugInfo();

  console.log('Environment Variables:');
  console.table({
    'Login Required': debugInfo.VITE_LOGIN_REQUIRED,
    'Force Login Enabled': debugInfo.VITE_FORCE_LOGIN_ENABLED,
    'Login Email': debugInfo.VITE_LOGIN_EMAIL,
    'Password Exists': debugInfo.VITE_LOGIN_PASSWORD_EXISTS,
  });

  console.log('\nLocalStorage:');
  console.table({
    'Auth Key': debugInfo.localStorageAuth,
    'Expiry Key': debugInfo.localStorageExpiry,
  });

  if (debugInfo.localStorageExpiry) {
    const expiryTime = parseInt(debugInfo.localStorageExpiry, 10);
    const now = Date.now();
    const remaining = expiryTime - now;
    const remainingMinutes = Math.floor(remaining / 1000 / 60);

    console.log('\nSession Info:');
    console.log(`Expires at: ${new Date(expiryTime).toLocaleString()}`);
    console.log(`Time remaining: ${remainingMinutes} minutes`);
    console.log(`Is expired: ${remaining <= 0}`);
  }

  console.groupEnd();

  return debugInfo;
};
